export default __webpack_public_path__ + "static/race-day-half-marathon-vertical-c7665d161c35e9ba6577afa3c80a7189.png";